import TContractEditCancelAccountComplete from './index.vue';

TContractEditCancelAccountComplete.install = app => {
  app.component(TContractEditCancelAccountComplete.name, TContractEditCancelAccountComplete);
};

export default TContractEditCancelAccountComplete;
